import { Component, ViewChild, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { Service } from '../../direct-connect.service';
import { ClrWizard } from '@clr/angular';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
let $ = require('jquery');
import { AppState } from '../../../../../app.service';
import { IpValidationUtils  } from '../../../../../../common/validations/ip-validation-utils';
const _ = require('lodash');
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';

@Component({
  selector: 'edit-gateway-wizard',
  styles: [require('../../direct-connect.scss')],
  template: require('./edit-gateway.html'),
   providers: [
    Service, TranslateService
  ]
})

export class EditGatewayWizard {
  @ViewChild('connect_gateway_wizard') wizard: ClrWizard;
  @Input() isWizardOpen: boolean = false;

  @Input() orgVdcId: string = '';
  @Input() createData: any;
  @Input() editData: any;
  @Output() wizStatusChange: EventEmitter<any> = new EventEmitter();

  disableStep0: boolean = false;
  disableStep1: boolean = false;

  orgList: JSON;

  public stepData = [];
  public currentStepData = [];
  private subscribeHandler;

  private wizardType: string = 'Create';
  private uplinks: any;
  private isTranslationready:boolean = true;
  private crudResult: any;
  private networkDetail: any;
  private showBusy: boolean = false;
  private isNetworkCreated: boolean = false;
  private ipValidationUtils: IpValidationUtils = new IpValidationUtils();
  private newUplinks: any;
  private edgeName: string = '';
  constructor(public appState: AppState,
              public service: Service,
              private translate: TranslateService,
              private alert: VcaAlertsService) {
        translate.use(GlobalVariables.LOCALE);
  }

  toggleNextButtonStatus(state: boolean) {
      this.disableStep0 = state
      this.disableStep1 = state;
  }

  ngOnDestroy() {
    this.isWizardOpen = false;
  }

  setInitialData() {
    let edge = this.editData.edge;
    let dataModel = {
        ipRanges: _.cloneDeep(edge.ipRanges),
        existingIPRange: _.cloneDeep(edge.ipRanges),
        edgeId: edge.id,
        edgeName: edge.name,
        maskBits: edge.maskBits,
        gatewayAddress: edge.gatewayAddress,
        isStepValid: true,
        stepId: 0
    }
    this.stepData[0] = dataModel;
    this.edgeName = edge.name;
  }

  ngOnChanges(changes) {
    if (!this.isWizardOpen) {
        return;
    }
    this.setInitialData();
    this.getAllUplinksOfEdge();
  }


  getAllUplinksOfEdge() {
    this.disableStep1 = true;
    let edgeId = (this.editData.edge)?this.editData.edge.id:'';
      if (!edgeId) {
        return;
      }
      this.subscribeHandler = this.service.getAllUplinksOfEdge(edgeId)
        .subscribe(
        uplinks => {
          this.uplinks = uplinks;
          this.disableStep1 = false;
        },
        error => {
          this.service.logError(error, 'get uplinks error');
           this.alert.danger(['Failed to get Uplinks', error], 'manage-uplinks-edit');
           this.disableStep1 = true;
        },
        () => this.service.logOperationCompleted('get uplinks Completed')
      );
  }

  getNewUplinks() {
      if (!this.createData) {
          return;
      }
      let data = this.createData;
      let networkId = data.network.id;
      let found: boolean = false;
      let gatewayInterfaces = this.uplinks.gatewayInterfaces;
      for (let i = 0; i < gatewayInterfaces.length; i++) {
          if (gatewayInterfaces[i].networkId === networkId) {
            found = true;
            break;
          }
      }
      if (!found) {
          this.newUplinks = {
              'networkName': data.network.name ? data.network.name: '',
              'networkId': data.network.id ? data.network.id : '' ,
              'operation': 'add' ,
              'add': true,
              'defaultRoute' : false,
              'connected' : true,
              'subnets': data.subnets ? data.subnets : []
          }
      }
  }

  nextButtonClicked(stepId) {
      if (stepId === 2) {
          this.postData();
      }
  }

  wizardStateChanged(isItOpen) {
    this.isWizardOpen = isItOpen;
    this.wizStatusChange.emit(isItOpen);
  }

  wizardPageOnLoad(event) {
  }

  onOrgChange(event) {
    this.stepData[event.stepId] = event;
  };

  isWizardOpenChange() {
  }

  toggleNextButton(formData) {
    this.currentStepData = formData;
    switch (formData.stepId) {
      // Configure Gateway
      case 0:
            this.stepData[0].ipRanges = (formData.ipRanges) ? formData.ipRanges : this.stepData[0].ipRanges;
            setTimeout(() => this.disableStep0 = !formData.isStepValid, 10);
      break;

      // Manage Uplinks
      case 1:
        this.stepData[formData.stepId] = formData;
        setTimeout(() => this.disableStep1 = !formData.isStepValid, 10);
    }
  }

  postData() {
      let payload = this.getPayload();
      let edgeId = this.editData.edge.id;
      if (payload && edgeId) {
          this.updateUplinksOfEdge(payload, edgeId);
      }
  }

  updateUplinksOfEdge(data: any, edgeId: string) {
    if (!data) {
        return;
    }
    let obj = {'uplinks': data.uplinks.uplinks};
    this.subscribeHandler = this.service.updateUplinksOfEdge(obj, edgeId)
      .subscribe(
        crudResult => {
          this.crudResult = crudResult;
        },
        error => this.service.logError(error, 'updateUplinksOfEdge error'),
        () => this.service.logOperationCompleted('updateUplinksOfEdge Completed')
      );
  }

  getExistingIPRange () {
      let ranges = [];
      let rowData = this.getRowData();
      let dcNetworkId = rowData.network.id;
      if (!this.createData || !this.createData.edgesConnected) {
          return [];
      }
      this.createData.edgesConnected[0].gatewayInterfaces.map(function(inf, index){
          let _ranges = [];
          if(inf.networkId === dcNetworkId) {
            inf.subnets.map(function(subnet, idx){
                _ranges = _ranges.concat(subnet.ipRanges);
            });
            ranges = ranges.concat(_ranges);
        }
      });
      return ranges;
  }

  validateIpInSubnet (subnet,ips) {
      let __thisVar = this;
      let ipsValid = false;
      let subnetIP = $.trim(subnet[0]);
      let netMask  = $.trim(subnet[1]);
      ips.forEach(function(el){
         ipsValid = __thisVar.ipValidationUtils.isRangeValid(el['startAddress'], el['endAddress'],subnetIP,netMask);
          return !ipsValid;
      });
      return ipsValid;
    }

  computeRangeData (subnets, subIPRanges){
      let __this = this;
      let ret = [];
      subnets.map(function(subnetItem, index){
                let _index = index;
                subnetItem.ipRanges = [];
                subIPRanges.map(function(ipRange, idx){
                    let ipRanges = [];
                    ipRanges.push(ipRange);
                    let inSubnet = __this.validateIpInSubnet([subnetItem.gatewayAddress, subnetItem.maskBits], ipRanges);
                    if(inSubnet){
                      subnetItem.ipRanges.push(ipRange);
                    }
                });
                ret.push(subnetItem);
      });
      return ret;
  }

  getEdgeData() {
    let sData = this.stepData[0];
    let data = {
        gatewayRanges: {ipRanges: $.extend(true, [], sData.ipRanges)},
	      edgeId:  sData.edgeId,
	      edgeName: sData.edgeName,
        uplinks: []
    }
    return data;
  }

  getMainSubnets() {
      return this.createData.subnets;
  }

  getRowData() {
      return this.createData;
  }

  getUplinks() {
      if (this.uplinks && this.uplinks.gatewayInterfaces) {
          return this.uplinks.gatewayInterfaces;
      }
      return [];
  }

  isUplinkChecked(networkId: string) {
      let uplinksSelection = this.stepData[1].uplinksSelection;
      for (let i = 0; i < uplinksSelection.length; i++) {
          if (uplinksSelection[i].id === networkId && uplinksSelection[i].selected) {
              return true;
          }
      }
      return false;
  }


  getSubIPRanges() {
      return (this.stepData[0]? this.stepData[0].ipRanges: []);
  }

  getPayload() {
      let _thisVar = this;
      let edgeData = this.getEdgeData();
      let rowData =  this.editData.rowData;
      let data = {'uplinks' : []};
      let directConnectNetworkId = (rowData.network.id) ? rowData.network.id : null ;

      let mainSubnets  =  this.editData.rowData.subnets;
      let existingIPRange = this.stepData[0].existingIPRange;

      if (typeof rowData.network !== "undefined") {
          directConnectNetworkId = rowData.network.id;
      } else if (typeof edgeData !== "undefined") {
          directConnectNetworkId = edgeData['network']['id'];
      }

      let uplinks = this.getUplinks();
      let newUP = this.newUplinks;

      uplinks.map(function(item, index){
            let o = {};
            o = $.extend(true, {}, item);
            if(item.operation == 'add' && item.add == true) {
                o['defaultRoute'] = false;
                let subIPRanges = _thisVar.getSubIPRanges();
                o['subnets'] = _thisVar.computeRangeData(mainSubnets, subIPRanges);
                delete o['add'];
                delete o['connected'];
                data.uplinks.push(o);
            } else {
                let shouldUpdate = false;
                if(item.networkId == directConnectNetworkId) {
                  let ranges = _thisVar.stepData[0].ipRanges;
                  if (existingIPRange.length == ranges.length) {
                      existingIPRange.map(function(ip,i){ 
                        if ( (ip.endAddress != ranges[i].endAddress) || (ip.startAddress != ranges[i].startAddress)) {
                            shouldUpdate = true;
                            return true;
                        }
                      });
                  } else {
                      shouldUpdate = true;
                  }
                  if (shouldUpdate) {
                    o['subnets'] = _thisVar.computeRangeData(mainSubnets, ranges);
                    o['operation'] = "modify";
                  }
                }

                let itemChecked = _thisVar.isUplinkChecked(item.networkId)
                if(!itemChecked) {
                      o['operation'] = 'delete';
                      o['defaultRoute'] = false;
                      delete o['connected'];
                      data.uplinks.push(o);
                } else if(itemChecked && shouldUpdate) {
                  data.uplinks.push(o);
                }
          }
      });

    let modified = $.extend(true, {}, data);
    modified.uplinks.map(function(item, index){
          let subs = [];
          item.subnets.map(function(subnet, index){
                if('subnetId' in subnet){
                    delete subnet.subnetId;
                }
                if(!(item.networkId === directConnectNetworkId && subnet.ipRanges.length == 0)){
                    subs.push(subnet);
                }
          });
          item.subnets = subs;
    });
    edgeData.uplinks = modified;
    return edgeData;
  }

};



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/edit-gateway/edit-gateway.wizard.ts